import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const ContactSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-medium text-sm uppercase tracking-wider">
            {language === 'en' ? 'Contact Us' : 'Contactez-Nous'}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mt-3 mb-4">
            {t.contact.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.contact.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {/* Email */}
          <a
            href={`mailto:${siteInfo.email}`}
            className="group bg-stone-50 rounded-2xl p-8 text-center hover:bg-teal-50 transition-colors border border-stone-100 hover:border-teal-200"
          >
            <div className="w-16 h-16 rounded-xl bg-teal-100 text-teal-600 flex items-center justify-center mx-auto mb-5 group-hover:bg-teal-600 group-hover:text-white transition-colors">
              <Mail className="w-7 h-7" />
            </div>
            <h3 className="font-semibold text-stone-800 mb-2">{t.contact.email}</h3>
            <p className="text-teal-600 font-medium">{siteInfo.email}</p>
          </a>

          {/* WhatsApp */}
          <a
            href={siteInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-stone-50 rounded-2xl p-8 text-center hover:bg-green-50 transition-colors border border-stone-100 hover:border-green-200"
          >
            <div className="w-16 h-16 rounded-xl bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-5 group-hover:bg-green-600 group-hover:text-white transition-colors">
              <MessageCircle className="w-7 h-7" />
            </div>
            <h3 className="font-semibold text-stone-800 mb-2">{t.contact.whatsapp}</h3>
            <p className="text-green-600 font-medium">{siteInfo.whatsapp}</p>
          </a>

          {/* Address */}
          <a
            href={siteInfo.googleMapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-stone-50 rounded-2xl p-8 text-center hover:bg-amber-50 transition-colors border border-stone-100 hover:border-amber-200"
          >
            <div className="w-16 h-16 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center mx-auto mb-5 group-hover:bg-amber-600 group-hover:text-white transition-colors">
              <MapPin className="w-7 h-7" />
            </div>
            <h3 className="font-semibold text-stone-800 mb-2">{t.contact.address}</h3>
            <p className="text-stone-600 text-sm leading-relaxed">{siteInfo.address}</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;